(() => {
  const imageSelector = '.custom-product-layout-wrapper img:not(.feature-icon)';
  const dialogId = 'evolt-description-lightbox';
  const lockClass = 'evolt-description-lightbox-open';
  let lastTrigger = null;

  const ensureDialog = () => {
    let dialog = document.getElementById(dialogId);
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = dialogId;
    dialog.className = 'evolt-description-lightbox';
    dialog.setAttribute('aria-label', 'Povečana slika izdelka');
    dialog.innerHTML = '<button class="evolt-description-lightbox__close" type="button" aria-label="Zapri povečano sliko">&times;</button><img class="evolt-description-lightbox__image" alt="">';
    document.body.appendChild(dialog);

    const close = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove(lockClass);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    };

    dialog.querySelector('.evolt-description-lightbox__close').addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove(lockClass);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    return dialog;
  };

  const enhance = (root = document) => {
    root.querySelectorAll(imageSelector).forEach((image) => {
      if (image.dataset.evoltDescriptionLightbox === 'true') return;
      image.dataset.evoltDescriptionLightbox = 'true';
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-haspopup', 'dialog');
      image.setAttribute('aria-label', image.alt ? `Povečaj sliko: ${image.alt}` : 'Povečaj sliko izdelka');
    });
  };

  const open = (image) => {
    const source = image.currentSrc || image.src;
    if (!source) return;
    const dialog = ensureDialog();
    const fullImage = dialog.querySelector('.evolt-description-lightbox__image');
    fullImage.src = source;
    fullImage.alt = image.alt || '';
    lastTrigger = image;
    document.documentElement.classList.add(lockClass);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('.evolt-description-lightbox__close').focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const image = event.target.closest(imageSelector);
    if (!image) return;
    event.preventDefault();
    event.stopPropagation();
    open(image);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const dialog = document.getElementById(dialogId);
      if (dialog && dialog.hasAttribute('open') && typeof dialog.close !== 'function') {
        dialog.removeAttribute('open');
        document.documentElement.classList.remove(lockClass);
      }
      return;
    }
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!(event.target instanceof Element) || !event.target.matches(imageSelector)) return;
    event.preventDefault();
    open(event.target);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
